export class TipoEstupefacientes {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
